/**
 * Brand palette used by the customer dashboard cards.
 * Scoped to the redesigned cards (RightPanel, PolicySummaryPanel,
 * PolicyDetailsCard, DriverDetailsCard) via a local ThemeProvider so it does
 * not affect the rest of the app.
 */
export const brandColors = {
  primary: "rgb(46, 184, 172)", // teal
  secondary: "rgb(103, 197, 228)", // light blue
  highlight: "rgb(238, 140, 43)", // orange
  highlightSoft: "rgba(238, 140, 43, 0.12)",
};

export const brandThemeOptions = {
  palette: {
    primary: { main: brandColors.primary, contrastText: "#ffffff" },
    secondary: { main: brandColors.secondary, contrastText: "#ffffff" },
  },
};
